import { useBaseAPI } from 'apiServices/baseAPI';
import { oids, endpoints, currentMode } from 'configs';

export function usePatientSummaryAPI({
  purposeOfUse,
  organizationId,
  subjectId,
  resourceId,
  subjectToken,
}) {
  const numberOfDocsToRequest = 5;
  const bundleEntries = [
    {
      request: {
        method: 'GET',
        url: `Observation?code=http://loinc.org|55284-4&subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=final&_sort=-date&_count=1`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `Observation?code=http://loinc.org|29463-7&subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=final&_sort=-date&_count=1`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `Observation?code=http://loinc.org|8302-2&subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=final&_sort=-date&_count=1`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `Condition?code=2.16.840.1.113883.6.3|,http://www.saude.gov.br/fhir/r4/CodeSystem/BRCID10|&subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&_sort=-recorded-date&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `Condition?code=2.16.840.1.113883.6.139|,http://www.saude.gov.br/fhir/r4/CodeSystem/BRCIAP2|&subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&_sort=-recorded-date&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `AllergyIntolerance?patient=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&_sort=-date&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `Procedure?patient=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=completed&_sort=-date&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `MedicationRequest?subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=active&_sort=-authoredon&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `DocumentReference?subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&type:coding=Sum%C3%A1rioAlta.v4.0,Sum%C3%A1rio%20de%20Alta%20v1.0&_sort=-period&_count=${numberOfDocsToRequest}`,
      },
    },
    {
      request: {
        method: 'GET',
        url: `ServiceRequest?subject=Patient/${resourceId.length === 11 ? oids.cpf : oids.cns}-${resourceId}&status=active,completed&_sort=-authored&_count=${numberOfDocsToRequest}`,
      },
    },
  ];
  return useBaseAPI(
    {
      method: 'POST',
      route: `${endpoints.MHD.split(`${endpoints.XDSB_domain}/`)[1]}`,
      additionalHeaders: {
        purposeofuse: purposeOfUse || 'Atendimento',
        ...(organizationId && { 'organization-id': organizationId }),
        ...(subjectId && { 'subject-id': subjectId }),
        ...(resourceId && currentMode === 'aghu' && { 'resource-id': resourceId }),
        ...(subjectToken && { authorization: `Bearer ${subjectToken}` }),
        ...(subjectToken && { 'x-user-token': subjectToken }),
      },
      data: {
        meta: {
          profile: [
            'http://ehrrunner.com/fhir/StructureDefinition/PatientSummary',
          ],
        },
        entry: bundleEntries,
        resourceType: 'Bundle',
      },
    },
    !resourceId,
  );
}
